import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./sidebar.css";
import { Home, Users, BarChart3, User, LogOut, X, DollarSign, Headphones, Briefcase } from "lucide-react";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogOut = () => {
    localStorage.clear();
    navigate('/')
  }

  // Sidebar menu items
  const menuItems = [
    { name: "Dashboard", icon: <Home size={18} />, path: "/dashboard" },
    { name: "Leads", icon: <Users size={18} />, path: "/leads" },
    { name: "Portfolio", icon: <Briefcase size={18} />, path: "/portfolio-list" },
    { name: "Analytics", icon: <BarChart3 size={18} />, path: "/analytics" },
    { name: "Commissions", icon: <DollarSign size={18} />, path: "/commissions" },
    { name: "Supports", icon: <Headphones size={18} />, path: "/supports" },
    { name: "Profile", icon: <User size={18} />, path: "/profile" },
  ];

  return (
    <div className={`rf-sidebar-div ${isOpen ? "open" : ""}`}>
      {/* Close btn (mobile only) */}
      <button className="rf-sidebar-close" onClick={onClose}>
        <X size={18} />
      </button>

      {/* Logo */}
      <div className="rf-sidebar-logo">
             <img
                  src="/wealth_compounders_logo.png"
                alt="Logo"
                className="rf-internal-logo-img"
              />
        <div>
          {/* <span>Partner Portal</span> */}
        </div>
      </div>

      {/* Menu */}
      <ul className="rf-sidebar-menu">
        {menuItems.map((item) => (
          <li
            key={item.name}
            className={location.pathname === item.path ? "active" : ""}
          >
            <Link to={item.path} onClick={onClose} className="rf-sidebar-link">
              {item.icon}{" "}
              <span
              
                style={{
                  fontWeight: location.pathname === item.path ? "bold" : "bold",
                }}
              >
                {item.name}
              </span>
            </Link>
          </li>
        ))}
      </ul>

      {/* Footer */}
      <div className="rf-sidebar-footer">
        <button onClick={handleLogOut} className="rf-sidebar-logout-btn">
          <LogOut size={16} /> Log Out
        </button>
        <p>Version 2.4.0</p>
      </div>

      {/* Overlay for mobile */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
    </div>
  );
};

export default Sidebar;
